import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Process from './components/Process';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { SITE_NAME, BRAND_COLOR } from './constants';

const App: React.FC = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.documentElement.style.setProperty('--brand-color', BRAND_COLOR);
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setIsDarkMode(true);
    }
    const timer = setTimeout(() => setIsLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  const toggleTheme = () => setIsDarkMode(!isDarkMode);

  const nameParts = SITE_NAME.split(' ');

  return (
    <div className={`min-h-screen transition-colors duration-500 selection:bg-brand selection:text-white ${isDarkMode ? 'bg-black text-white' : 'bg-white text-black'}`}>
      <AnimatePresence mode="wait">
        {isLoading && (
          <motion.div 
            key="loader"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, y: -20 }} 
            className="fixed inset-0 z-[200] bg-black flex items-center justify-center flex-col"
          >
            <h1 className="font-display text-4xl font-black text-white uppercase tracking-tighter">
              {nameParts[0]} <span style={{ color: BRAND_COLOR }}>{nameParts.slice(1).join(' ')}</span>
            </h1>
            <div className="h-[2px] w-24 bg-white/10 mt-4 overflow-hidden">
                <motion.div 
                  initial={{ x: '-100%' }} 
                  animate={{ x: '100%' }} 
                  transition={{ duration: 0.8, repeat: Infinity }} 
                  style={{ backgroundColor: BRAND_COLOR }} 
                  className="h-full w-full" 
                />
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <Navbar isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
      <main>
        <Hero isDarkMode={isDarkMode} />
        <Portfolio isDarkMode={isDarkMode} />
        <About isDarkMode={isDarkMode} />
        <Process isDarkMode={isDarkMode} />
        <Pricing isDarkMode={isDarkMode} />
        <Contact isDarkMode={isDarkMode} />
      </main>
      <Footer isDarkMode={isDarkMode} />
    </div>
  );
};

export default App;